import { render, staticRenderFns } from "./AdminTradeCancel.vue?vue&type=template&id=b162134c&scoped=true&"
import script from "./AdminTradeCancel.vue?vue&type=script&lang=js&"
export * from "./AdminTradeCancel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b162134c",
  null
  
)

export default component.exports